var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.field.item.status)?_c('feather',{attrs:{"type":"circle","stroke":"#FFFFFF","stroke-width":"1","size":"12px","fill":"#81BA01","stroke-linejoin":"round"}}):_vm._e(),(!_vm.field.item.status)?_c('feather',{attrs:{"type":"circle","stroke":"#FFFFFF","stroke-width":"1","size":"12px","fill":"#FBBC58","stroke-linejoin":"round"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }